// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__h0oX8"};